module.exports = __webpack_public_path__ + "img/HowItWorks-UpdateWill.0ec2d69f.jpg";